import { all } from '../data/all';

function Capitals() {

    let countryData = [];
    
    all.forEach(thisCountry => {
        if (thisCountry.capital) { // null values...
            countryData = [...countryData, thisCountry.capital];
        }
    })

    countryData.sort();

    return(
        <code>
            { JSON.stringify(countryData) }
        </code>
    )
}

export default Capitals;